import React from "react";
import styled, { css } from "styled-components";
import constants from "./constants";

const Card = styled.div`
  ${constants.nonExportedCss};

  font-family: ${({ uiKitConfiguration }) => {
    return uiKitConfiguration.font_family || "Arial";
  }};
  display: block;
  padding: 20px;

  border-radius: ${({ uiKitConfiguration }) => {
    if (uiKitConfiguration.border_radius) {
      return Math.min(
        uiKitConfiguration.border_radius,
        constants.maxValues.card.borderRadius,
      );
    } else {
      return constants.defaults.card.borderRadius;
    }
  }}px;

  border-width: 1px;
  border-style: solid;
  ${({ uiKitConfiguration }) => {
    return css`
      border-color: ${uiKitConfiguration.colors &&
      uiKitConfiguration.colors["color-gray-300"]};
      background-color: ${uiKitConfiguration.colors &&
      uiKitConfiguration.colors["color-gray-100"]};
    `;
  }};

  box-shadow: ${({ uiKitConfiguration }) => {
    return uiKitConfiguration.box_shadow || constants.defaults.card.boxShadow;
  }};
`;

export default Card;
